<template>
  <div>
      <vs-popup fullscreen :title="title" :active.sync="isActive" @close="close" class="pb-5">
        <vs-row vs-w="12">
          <vs-col>
            <iframe :src="src" class="w-full show-pdf" :style="{height:heightPDF+'vh'}"></iframe>
          </vs-col>
        </vs-row>
      </vs-popup>
  </div>
</template>

<script>
export default {
  data:function(){
    return {
      isActive:false
    }
  },
  computed:{
    active () {
      return this.$store.state.pdfViewer.active
    },
    src () {
      return this.$store.state.pdfViewer.src
    },
    title() {
      return this.$store.state.pdfViewer.title
    },
    heightPDF () {
      let output='83';
      /* if(this.$store.state.windowWidth<700){
        output='50';
      } */
      return output
    }
  },
  watch:{
    active(val){
        this.isActive = this.active
    }
  },
  methods:{
    close () {
      this.$store.dispatch('togglePdfViewer', { active: false, src: '',title:''})
    }
  }
}
</script>

<style lang="css" scoped>
/* 1366 x 768 */
.show-pdf {
    display: block;       
    border: none;           
}

</style>